var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgXmark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_544",
    "data-name": "\\uADF8\\uB8F9 544",
    transform: "translate(-1111 -274.287)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_89",
    "data-name": "\\uD0C0\\uC6D0 89",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(1111 274.287)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_543",
    "data-name": "\\uADF8\\uB8F9 543",
    transform: "translate(1119 282.287)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1196",
    "data-name": "\\uD328\\uC2A4 1196",
    d: "M0,14l3.063-3.062L14,0",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_2",
    "data-name": "\\uC120 2",
    x2: 13.964,
    y2: 13.964,
    transform: "translate(0 0.036)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXmark);
export default __webpack_public_path__ + "static/media/xmark.3987fe29ceaa2c60308f019e5348cf64.svg";
export { ForwardRef as ReactComponent };